import type { FunctionComponent } from "react";

import ThumbsUp from "@uui/ThumbsUp";
import X from "@uui/X";

import Check from "@mui/icons-material/Check";
import styled from "@mui/material/styles/styled";

import Stack, { Row, StackProps } from "@rui/Stack";

export const RECOMMENDATION_CATEGORY_PROPS = {
  accepted: {
    title: "Accepted / Completed",
    icon: <Check sx={{ color: "shades.positive.600" }} />,
    color: "shades.positive.50",
  },
  acknowledged: {
    title: "Acknowledged",
    icon: <ThumbsUp sx={{ color: "shades.secondary.500" }} />,
    color: "shades.secondary.50",
  },
  rejected: {
    title: "Ignored",
    icon: <X sx={{ color: "error.main" }} />,
    color: "shades.negative.50",
  },
};

export const Chip = styled<FunctionComponent<StackProps>>((props) => (
  <Row variant="center" spacing={0.5} {...props} />
))(({ theme }) => ({
  borderRadius: "2px",
  color: theme.palette.shades.neutral[600],
  fontWeight: 500,
  padding: theme.spacing(0, 1, 0, 0.5),
  "& .MuiSvgIcon-root": {
    fontSize: "16px",
  },
}));

const RecommendationCategoryItemOuterContainer = styled(Stack)(({ theme }) => ({
  color: theme.palette.shades.neutral[800],
  padding: theme.spacing(0.5, 0),
  borderBottom: `1px solid ${theme.palette.shades.neutral[50]}`,
}));

const RecommendationCategoryItemInnerContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  "&:hover": {
    cursor: "pointer",
    backgroundColor: theme.palette.shades.ghost[300],
  },
}));

export const RecommendationCategoryItemContainer = (props: StackProps) => (
  <RecommendationCategoryItemOuterContainer>
    <RecommendationCategoryItemInnerContainer {...props} />
  </RecommendationCategoryItemOuterContainer>
);
